import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const H2 = ({ children }) => (
  <h2 className="font-display text-2xl mt-8 mb-2 border-l-4 border-[var(--pc-red)] pl-3">{children}</h2>
);

function ContentES() {
  return (
    <>
      <p>
        El acceso a este Sitio Web puede implicar la utilización de cookies. Las cookies son pequeñas cantidades de
        información que se almacenan en el navegador utilizado por cada Usuario —en los distintos dispositivos que
        pueda utilizar para navegar— para que el servidor recuerde cierta información que posteriormente y
        únicamente el servidor que la implementó leerá. Las cookies facilitan la navegación, la hacen más amigable,
        y no dañan el dispositivo de navegación.
      </p>
      <p>
        Las cookies son procedimientos automáticos de recogida de información relativa a las preferencias
        determinadas por el Usuario durante su visita al Sitio Web con el fin de reconocerlo como Usuario, y
        personalizar su experiencia y el uso del Sitio Web, y pueden también, por ejemplo, ayudar a identificar y
        resolver errores.
      </p>
      <p>
        La información recabada a través de las cookies puede incluir la fecha y hora de visitas al Sitio Web, las
        páginas visionadas, el tiempo que ha estado en el Sitio Web y los sitios visitados justo antes y después del
        mismo. Sin embargo, ninguna cookie permite que esta misma pueda contactarse con el número de teléfono del
        Usuario o con cualquier otro medio de contacto personal. Ninguna cookie puede extraer información del disco
        duro del Usuario o robar información personal. La única manera de que la información privada del Usuario
        forme parte del archivo Cookie es que el usuario dé personalmente esa información al servidor.
      </p>
      <p>
        Las cookies que permiten identificar a una persona se consideran datos personales. Por tanto, a las mismas
        les será de aplicación la Política de Privacidad anteriormente descrita. En este sentido, para la
        utilización de las mismas será necesario el consentimiento del Usuario. Este consentimiento será comunicado,
        en base a una elección auténtica, ofrecido mediante una decisión afirmativa y positiva, antes del
        tratamiento inicial, removible y documentado.
      </p>

      <H2>Cookies propias</H2>
      <p>
        Son aquellas cookies que son enviadas al ordenador o dispositivo del Usuario y gestionadas exclusivamente
        por pillauncoche para el mejor funcionamiento del Sitio Web. La información que se recaba se emplea para
        mejorar la calidad del Sitio Web y su Contenido y su experiencia como Usuario. Estas cookies permiten
        reconocer al Usuario como visitante recurrente del Sitio Web y adaptar el contenido para ofrecerle contenidos
        que se ajusten a sus preferencias.
      </p>

      <H2>Cookies de terceros</H2>
      <p>
        Son cookies utilizadas y gestionadas por entidades externas que proporcionan a pillauncoche servicios
        solicitados por este mismo para mejorar el Sitio Web y la experiencia del usuario al navegar en el Sitio Web.
        Los principales objetivos para los que se utilizan cookies de terceros son la obtención de estadísticas de
        accesos y analizar la información de la navegación, es decir, cómo interactúa el Usuario con el Sitio Web.
      </p>
      <p>
        La información que se obtiene se refiere, por ejemplo, al número de páginas visitadas, el idioma, el lugar
        a la que la dirección IP desde el que accede el Usuario, el número de Usuarios que acceden, la frecuencia y
        reincidencia de las visitas, el tiempo de visita, el navegador que usan, el operador o tipo de dispositivo
        desde el que se realiza la visita. Esta información se utiliza para mejorar el Sitio Web, y detectar nuevas
        necesidades para ofrecer a los Usuarios un Contenido y/o servicio de óptima calidad. En todo caso, la
        información se recopila de forma anónima y se elaboran informes de tendencias del Sitio Web sin identificar
        a usuarios individuales.
      </p>
      <p>
        La(s) entidad(es) encargada(s) del suministro de cookies podrá(n) ceder esta información a terceros, siempre
        y cuando lo exija la ley o sea un tercero el que procese esta información para dichas entidades.
      </p>

      <H2>Cookies de redes sociales</H2>
      <p>
        pillauncoche incorpora plugins de redes sociales, que permiten acceder a las mismas a partir del Sitio Web.
        Por esta razón, las cookies de redes sociales pueden almacenarse en el navegador del Usuario. Los titulares
        de dichas redes sociales disponen de sus propias políticas de protección de datos y de cookies, siendo ellos
        mismos, en cada caso, responsables de sus propios ficheros y de sus propias prácticas de privacidad. El
        Usuario debe referirse a las mismas para informarse acerca de dichas cookies y, en su caso, del tratamiento
        de sus datos personales. Únicamente a título informativo se indican a continuación los enlaces en los que se
        pueden consultar dichas políticas de privacidad y/o de cookies:
      </p>
      <ul className="list-disc pl-6 space-y-1 text-sm">
        <li>Facebook: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://www.facebook.com/policies/cookies/" target="_blank" rel="noreferrer">https://www.facebook.com/policies/cookies/</a></li>
        <li>Twitter: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://twitter.com/es/privacy" target="_blank" rel="noreferrer">https://twitter.com/es/privacy</a></li>
        <li>Instagram: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://help.instagram.com/1896641480634370?ref=ig" target="_blank" rel="noreferrer">https://help.instagram.com/1896641480634370?ref=ig</a></li>
        <li>YouTube: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://policies.google.com/privacy?hl=es-419&gl=mx" target="_blank" rel="noreferrer">https://policies.google.com/privacy?hl=es-419&amp;gl=mx</a></li>
        <li>Pinterest: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://policy.pinterest.com/es/privacy-policy" target="_blank" rel="noreferrer">https://policy.pinterest.com/es/privacy-policy</a></li>
        <li>LinkedIn: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://www.linkedin.com/legal/cookie-policy?trk=hp-cookies" target="_blank" rel="noreferrer">https://www.linkedin.com/legal/cookie-policy?trk=hp-cookies</a></li>
      </ul>

      <H2>Deshabilitar, rechazar y eliminar cookies</H2>
      <p>
        El Usuario puede deshabilitar, rechazar y eliminar las cookies —total o parcialmente— instaladas en su
        dispositivo mediante la configuración de su navegador (entre los que se encuentran, por ejemplo, Chrome,
        Firefox, Safari, Explorer). En este sentido, los procedimientos para rechazar y eliminar las cookies pueden
        diferir de un navegador de Internet a otro. En consecuencia, el Usuario debe acudir a las instrucciones
        facilitadas por el propio navegador de Internet que esté utilizando. En el supuesto de que rechace el uso de
        cookies —total o parcialmente— podrá seguir usando el Sitio Web, si bien podrá tener limitada la utilización
        de algunas de las prestaciones del mismo.
      </p>

      <p className="text-xs text-neutral-500 border-t border-neutral-200 pt-4 mt-8">
        Este documento de Política de Cookies ha sido creado mediante el generador de plantilla de política de
        cookies web gratis online el día 03/07/2026.
      </p>
    </>
  );
}

function ContentEN() {
  return (
    <>
      <p>
        Accessing this Website may involve the use of cookies. Cookies are small pieces of information stored in
        the browser used by each User — on the various devices they may use to browse — so that the server can
        remember certain information which will later be read only by the server that set it. Cookies make
        browsing easier, more user-friendly, and do not damage the browsing device.
      </p>
      <p>
        Cookies are automatic procedures for collecting information about the preferences determined by the User
        during their visit to the Website, in order to recognise them as a User, and to personalise their
        experience and use of the Website; they can also, for example, help identify and fix errors.
      </p>
      <p>
        The information collected through cookies may include the date and time of visits to the Website, the
        pages viewed, the time spent on the Website, and the sites visited immediately before and after it.
        However, no cookie allows itself to contact the User's phone number or any other personal contact method.
        No cookie can extract information from the User's hard drive or steal personal information. The only way
        for the User's private information to become part of the Cookie file is if the user personally provides
        that information to the server.
      </p>
      <p>
        Cookies that allow a person to be identified are considered personal data. Therefore, the Privacy Policy
        described above applies to them. In this regard, the User's consent is required to use them. This consent
        will be given based on a genuine choice, offered through an affirmative and positive decision, before the
        initial processing, and will be revocable and documented.
      </p>

      <H2>Own (first-party) cookies</H2>
      <p>
        These are cookies sent to the User's computer or device and managed exclusively by pillauncoche for the
        proper functioning of the Website. The information collected is used to improve the quality of the Website
        and its Content, and the User's experience. These cookies make it possible to recognise the User as a
        returning visitor to the Website and to adapt the content to match their preferences.
      </p>

      <H2>Third-party cookies</H2>
      <p>
        These are cookies used and managed by external entities that provide pillauncoche with services it has
        requested in order to improve the Website and the user experience while browsing it. The main purposes for
        which third-party cookies are used are obtaining access statistics and analysing browsing information —
        i.e. how the User interacts with the Website.
      </p>
      <p>
        The information obtained refers, for example, to the number of pages visited, the language, the location
        derived from the IP address the User accesses from, the number of Users accessing the site, the frequency
        and recurrence of visits, the time spent visiting, the browser used, and the operator or type of device
        the visit is made from. This information is used to improve the Website and identify new needs in order
        to offer Users the best possible Content and/or service. In all cases, the information is collected
        anonymously and trend reports about the Website are produced without identifying individual users.
      </p>
      <p>
        The entity/entities responsible for providing cookies may share this information with third parties,
        provided the law requires it or a third party processes this information on behalf of those entities.
      </p>

      <H2>Social media cookies</H2>
      <p>
        pillauncoche includes social media plugins that allow access to those networks from the Website. For this
        reason, social media cookies may be stored in the User's browser. The owners of those social networks have
        their own data protection and cookie policies, and are themselves responsible, in each case, for their own
        files and privacy practices. The User should refer to those policies for information about such cookies
        and, where applicable, the processing of their personal data. For informational purposes only, the links
        where those privacy and/or cookie policies can be consulted are listed below:
      </p>
      <ul className="list-disc pl-6 space-y-1 text-sm">
        <li>Facebook: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://www.facebook.com/policies/cookies/" target="_blank" rel="noreferrer">https://www.facebook.com/policies/cookies/</a></li>
        <li>Twitter: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://twitter.com/es/privacy" target="_blank" rel="noreferrer">https://twitter.com/es/privacy</a></li>
        <li>Instagram: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://help.instagram.com/1896641480634370?ref=ig" target="_blank" rel="noreferrer">https://help.instagram.com/1896641480634370?ref=ig</a></li>
        <li>YouTube: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">https://policies.google.com/privacy</a></li>
        <li>Pinterest: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://policy.pinterest.com/en/privacy-policy" target="_blank" rel="noreferrer">https://policy.pinterest.com/en/privacy-policy</a></li>
        <li>LinkedIn: <a className="link-hover-red text-[var(--pc-red)] break-all" href="https://www.linkedin.com/legal/cookie-policy" target="_blank" rel="noreferrer">https://www.linkedin.com/legal/cookie-policy</a></li>
      </ul>

      <H2>Disabling, rejecting and deleting cookies</H2>
      <p>
        The User can disable, reject and delete cookies — in full or in part — installed on their device through
        their browser settings (including, for example, Chrome, Firefox, Safari, or Explorer). Procedures for
        rejecting and deleting cookies may differ between browsers. Accordingly, the User should follow the
        instructions provided by the specific browser they are using. If the User rejects the use of cookies —
        in full or in part — they may continue to use the Website, although some of its features may be limited.
      </p>

      <p className="text-xs text-neutral-500 border-t border-neutral-200 pt-4 mt-8">
        This Cookie Policy document was created using a free online cookie-policy template generator on 03/07/2026.
      </p>
    </>
  );
}

export default function Cookies() {
  const { i18n } = useTranslation();
  const isEn = i18n.language?.startsWith("en");

  return (
    <section className="section-light py-16" data-testid="cookies-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="divider-red mb-4"></div>
        <h1 className="font-display text-4xl sm:text-5xl mb-2">{isEn ? "Cookie Policy" : "Política de Cookies"}</h1>
        <p className="text-xs uppercase tracking-widest text-neutral-500 mb-8">
          {isEn ? "Official document · pillauncoche S.L." : "Documento oficial · pillauncoche S.L."}
        </p>

        <article className="prose prose-neutral max-w-none text-base leading-relaxed text-neutral-800 space-y-5">
          {isEn ? <ContentEN /> : <ContentES />}
        </article>

        <div className="mt-10 flex justify-center">
          <Link to="/" className="btn-red px-8 py-3 text-sm uppercase tracking-widest" data-testid="cookies-accept-btn">
            {isEn ? "Accept and Return Home" : "Aceptar y Volver al Inicio"}
          </Link>
        </div>
      </div>
    </section>
  );
}
